import { useQuery } from '@tanstack/react-query';
import { contentApi } from '@/services/adminApi';

/**
 * Resolves profilePictureId to fileUrl via GET /api/v1/contents/profile-picture/{id} (public, no auth).
 * Use response.fileUrl as <img src={fileUrl} />. On 404 or error, returns null (show placeholder).
 */
export function useProfilePictureUrl(profilePictureId: string | null | undefined) {
  const { data: url, isLoading, isError } = useQuery({
    queryKey: ['profile-picture-url', profilePictureId],
    queryFn: async () => {
      if (!profilePictureId) return null;
      const content = await contentApi.getProfilePicture(profilePictureId);
      return content?.fileUrl ?? null;
    },
    enabled: !!profilePictureId,
    staleTime: 5 * 60 * 1000, // 5 min
    retry: false, // 404 = no picture, don't retry
  });

  return { url: url ?? null, isLoading, isError };
}
